import React from "react";
import SummaryStep from "./SummaryStep/SummaryStep";
import TreatmentLocationStep from "./TreatmentLocationStep/TreatmentLocationStep";
import TreatmentOptions from "./TreatmentOptionsStep/TreatmentOptions";
import WelcomeStep from "./WelcomeStep/WelcomeStep";

const MembershipContent = ({
  setActiveStep,
  handleNextStep,
  handleBackStep,
  totalSteps,
  activeStep,
  subActiveStep,
  setSubActiveStep,
  setLocation,
  location,
  massageCardsData,
  setMassageCardsData,
  performanceData,
  setPerformanceData,
  bodyTransformationData,
  setBodyTransformationData,
  handleIncrementSession,
  handleDecrementSession,
  cuppingTherapyData,
  setCuppingTherapydata,
  advancedElectroMuscularData,
  setAdvancedElectroMuscularData,
  manipulativeTherapyData,
  setManipulativeTherapyData,
  physiotherapyData,
  setPhysiotherapyData,
  acupunctureData,
  setAcupunctureData,
}) => {
  const memberships = {
    0: <WelcomeStep handleNextStep={handleNextStep} />,
    1: (
      <TreatmentLocationStep
        handleNextStep={handleNextStep}
        handleBackStep={handleBackStep}
        setLocation={setLocation}
        location={location}
      />
    ),
    2: (
      <TreatmentOptions
        handleNextStep={handleNextStep}
        handleBackStep={handleBackStep}
        subActiveStep={subActiveStep}
        massageCardsData={massageCardsData}
        setMassageCardsData={setMassageCardsData}
        performanceData={performanceData}
        setPerformanceData={setPerformanceData}
        bodyTransformationData={bodyTransformationData}
        setBodyTransformationData={setBodyTransformationData}
        handleIncrementSession={handleIncrementSession}
        handleDecrementSession={handleDecrementSession}
        cuppingTherapyData={cuppingTherapyData}
        setCuppingTherapydata={setCuppingTherapydata}
        advancedElectroMuscularData={advancedElectroMuscularData}
        setAdvancedElectroMuscularData={setAdvancedElectroMuscularData}
        manipulativeTherapyData={manipulativeTherapyData}
        setManipulativeTherapyData={setManipulativeTherapyData}
        physiotherapyData={physiotherapyData}
        setPhysiotherapyData={setPhysiotherapyData}
        acupunctureData={acupunctureData}
        setAcupunctureData={setAcupunctureData}
        handlePayNow={() => setActiveStep(3)}
      />
    ),
    3: (
      <SummaryStep
        location={location}
        setActiveStep={setActiveStep}
        setSubActiveStep={setSubActiveStep}
        massageCardsData={massageCardsData}
        performanceData={performanceData}
        bodyTransformationData={bodyTransformationData}
        cuppingTherapyData={cuppingTherapyData}
        advancedElectroMuscularData={advancedElectroMuscularData}
        manipulativeTherapyData={manipulativeTherapyData}
        physiotherapyData={physiotherapyData}
        acupunctureData={acupunctureData}
      />
    ),
  };
  return (
    <div className="grid grid-cols-12 justify-center my-8 sm:my-16">
      <div className="col-span-10 flex flex-col items-center">
        <div className="w-5/6 lg:w-[680px]">
          <p className="font-font-Montserrat font-semibold text-[32px] sm:text-[48px] text-[#141414] text-center uppercase leading-[32px] sm:leading-[62px]">
            Create Custom MEMBERSHIP Plan
          </p>
          {memberships[activeStep]}
        </div>
      </div>
      <div>
        <p className="font-font-Titillium font-bold text-[22px] text-[#FAAD14] leading-[33px] w-[85px] tracking-[0.0094em]">
          {activeStep + 1 + "/" + totalSteps}
        </p>
      </div>
    </div>
  );
};

export default MembershipContent;
